// Filename - pages/Welcome.js

import React from "react";

export const Welcome = () => {
    return (
        <div className="welcome">
            <table align="center" width="90%">
                <tr align="center">
                    <td align="center">
                        <h3>
                            Welcome to InfoTrawl
                        </h3>
                    </td>
                </tr>
            </table>
        </div>
    );
};

export default Welcome;

